import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

const mountEl = document.querySelector('#cp-audiobook-pt')
const admin = mountEl?.dataset?.admin === 'true'

new Vue({
  vuetify,
  render: h => h(App, { props: { admin }})
}).$mount('#cp-audiobook-pt')
